import React from 'react';

import { message } from 'antd';
import { useIntl } from 'react-intl';

import { ButtonContainer, InfoMessage, InfoSection, ModalContent, StyledButton } from './SmidModalStyles';
import { Info } from '../../../icons/Info';
import { useTriggerSmidUpdateMutation } from '../../../stores/productProvidersSlice';
import Modal from '../Modal';

export interface SmidMissingMessages {
  title: string;
  explanation: string;
  extraText: string;
  buttonText: string;
  successMessage: string;
  errorMessage: string;
}

interface SmidMissingModalProps {
  onClose: () => void;
  productProvider?: { id: string };
}

const SmidMissingModal: React.FC<SmidMissingModalProps> = ({ onClose, productProvider }) => {
  const { messages } = useIntl();
  const smidMessages = messages.smidNotAppliedModal as unknown as SmidMissingMessages;
  const [triggerSmidUpdate, { isLoading }] = useTriggerSmidUpdateMutation();

  const applySmidFn = (): void => {
    triggerSmidUpdate({ productProviderId: productProvider?.id || '' })
      .unwrap()
      .then(() => {
        message.success(smidMessages.successMessage);
        onClose();
      })
      .catch(() => {
        message.error(smidMessages.errorMessage);
        onClose();
      });
  };

  if (!productProvider) {
    onClose();
  }

  return (
    <Modal
      title={smidMessages.title}
      handleCancel={onClose}
      handleOk={onClose}
      displayButtons={false}
      className="modal-mask--dark"
      footer={<></>}
    >
      <ModalContent>
        <InfoSection>
          <Info />
          <InfoMessage>
            {smidMessages.explanation}
            <br />
            {smidMessages.extraText}
          </InfoMessage>
        </InfoSection>

        <ButtonContainer>
          {isLoading ? (
            <StyledButton disabled>{smidMessages.buttonText}</StyledButton>
          ) : (
            <StyledButton onClick={() => applySmidFn()}>{smidMessages.buttonText}</StyledButton>
          )}
        </ButtonContainer>
      </ModalContent>
    </Modal>
  );
};

export default SmidMissingModal;
